import React from 'react';

export interface IconMailFullProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconMailFull: React.FC<IconMailFullProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <g clipPath="url(#clip0_29_1611)"> <path fillRule="evenodd" clipRule="evenodd" d="M2.00039 4H22.0002V6.28571V17.7143V20H2C2 20 2.00025 18.9767 2.00025 17.7143V6.28571L2.00039 4ZM6.41603 8.37596L5.79199 7.95994L4.95994 9.20801L5.58397 9.62404L11.584 13.624L12 13.9014L12.416 13.624L18.416 9.62404L19.0401 9.20801L18.208 7.95994L17.584 8.37596L12 12.0986L6.41603 8.37596Z" fill={fill || "#020617"} /> </g> <defs> <clipPath id="clip0_29_1611"> <rect width="24" height="24" fill={fill || "white"} /> </clipPath> </defs>  
    </svg>
  );
};

export default IconMailFull;
